module.exports = __webpack_public_path__ + "static/media/home-background.c27a9155.jpg";